module.exports = new __parcel__URL__("no_image.62092dc0.png").toString();